import React, {useState, useRef, useEffect} from "react";
import "./sections.scss";
import sampleVideo from "../../../assets/video/SampleVideo_1280x720.mp4"

function VideoSec({item}){

    let ref = useRef(null)

    const playVideo = ()=>{
        ref.current.play()
    }


    return(
        <div className="video-content" >
            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
            <video
                ref={ref}
                // onLoadedData={()=>playVideo()}
                width="100%" loop autoPlay muted>
                {/*<source src="https://www.w3schools.com/tags/movie.mp4" type="video/mp4" />*/}
                <source src={item.items[0].video} type="video/mp4" />
                        Your browser does not support the video tag.
            </video>
        </div>
    )
}

export default VideoSec
